module.exports = __webpack_public_path__ + "img/banner.52207e7d.png";